import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import SEO from '../../components/SEO';
import Header from '../../components/ui/Header';
import Footer from '../../components/ui/Footer';
import { Phone } from 'lucide-react';

const SelfDriveMain = () => {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  const cities = [
    { name: 'Chandigarh', displayName: 'Self drive car Rental in Chandigarh' },
    { name: 'Mohali', displayName: 'Self drive car Rental in Mohali' },
    { name: 'Panchkula', displayName: 'Self drive car Rental in Panchkula' }
  ];

  const handleViewCabs = (cityName) => {
    navigate(`/self-drive/${cityName?.toLowerCase()}`);
  };

  return (
    <>
      <SEO
        title="Self drive car Rental Service - Select a City to View Cabs | Advait Tour and Travels"
        description="Rent self-drive cars from major cities. Choose from a wide range of vehicles. Flexible rental options and affordable rates."
        keywords="self drive car rental, self drive cars, car rental service, rent a car"
        canonicalUrl={`${window.location?.origin}/self-drive`}
        ogTitle="Self drive car Rental Service - Select a City to View Cabs | Advait Tour and Travels"
        ogDescription="Rent self-drive cars from major cities. Choose from a wide range of vehicles. Flexible rental options and affordable rates."
        ogUrl={`${window.location?.origin}/self-drive`}
        structuredData={{
          "@context": "https://schema.org",
          "@type": "LocalBusiness",
          "name": "Advait Tour and Travels",
          "description": "Self drive car rental service"
        }}
      />

      <div className="min-h-screen bg-background">
        <Header />
        
        <main className="py-20">
          {/* Hero Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-16 mb-12">
            <div className="container mx-auto px-4">
              <h1 className="text-4xl md:text-5xl font-bold text-white text-center">
                Self drive car Rental Service
              </h1>
              <p className="text-xl text-white text-center mt-4">
                Select a City to View Cabs
              </p>
            </div>
          </div>

          {/* City Cards */}
          <div className="container mx-auto px-4 mb-16">
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6 max-w-6xl mx-auto">
              {cities?.map((city, index) => (
                <div
                  key={index}
                  className="bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all duration-300 p-6"
                >
                  <h3 className="text-xl font-bold text-gray-800 mb-4 text-center">
                    {city?.displayName}
                  </h3>
                  <button
                    onClick={() => handleViewCabs(city?.name)}
                    className="w-full py-3 bg-yellow-400 hover:bg-yellow-500 text-gray-900 font-bold rounded-lg transition-colors duration-300"
                  >
                    VIEW CABS
                  </button>
                </div>
              ))}
            </div>
          </div>

          {/* Contact Section */}
          <div className="bg-gradient-to-r from-blue-500 to-blue-600 py-12">
            <div className="container mx-auto px-4 text-center">
              <h2 className="text-3xl md:text-4xl font-bold text-white mb-4">
                We're here for you 24/7!
              </h2>
              <p className="text-xl text-white mb-6">
                Give us a call anytime
              </p>
              <a
                href="tel:+917998666660"
                className="inline-flex items-center gap-3 px-8 py-4 bg-white text-blue-600 font-bold text-2xl rounded-full hover:bg-gray-100 transition-colors duration-300"
              >
                <Phone className="w-6 h-6" />
                +91-79986-66660
              </a>
            </div>
          </div>
        </main>

        <Footer />
      </div>
    </>
  );
};

export default SelfDriveMain;